// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const WidgetRouteTruck: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    color1 = "#231f20",
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 22 19" width={width} height={height}>
            <path
                fill="currentColor"
                d="M2.2 1.375c-.608 0-1.1.503-1.1 1.125v10.125c0 .622.492 1.125 1.1 1.125h.19c.453-1.311 1.673-2.25 3.11-2.25s2.66.939 3.11 2.25h4.59V2.5c0-.622-.492-1.125-1.1-1.125zm0 13.5c-1.213 0-2.2-1.009-2.2-2.25V2.5C0 1.259.987.25 2.2.25h9.9c1.213 0 2.2 1.009 2.2 2.25v1.125h2.245c.48 0 .938.214 1.25.59l2.706 3.228c.258.306.399.696.399 1.097v5.21h.55c.302 0 .55.253.55.563s-.248.562-.55.562H19.8c0 1.863-1.478 3.375-3.3 3.375s-3.3-1.512-3.3-3.375H8.8c0 1.863-1.478 3.375-3.3 3.375s-3.3-1.512-3.3-3.375m12.1-6.75h5.325L16.96 4.947a.55.55 0 0 0-.416-.197H14.3zm0 1.125v3.108a3.25 3.25 0 0 1 2.2-.858c1.437 0 2.66.939 3.11 2.25h.19v-4.5zm-6.6 5.625a2.26 2.26 0 0 0-1.1-1.949 2.16 2.16 0 0 0-2.2 0 2.26 2.26 0 0 0-1.1 1.949c0 .804.42 1.547 1.1 1.949.68.401 1.52.401 2.2 0a2.26 2.26 0 0 0 1.1-1.949m8.8 2.25c.786 0 1.512-.429 1.905-1.125a2.3 2.3 0 0 0 0-2.25 2.19 2.19 0 0 0-1.905-1.125c-.786 0-1.512.429-1.905 1.125a2.3 2.3 0 0 0 0 2.25 2.19 2.19 0 0 0 1.905 1.125"
            />
        </svg>
    );
};

export default React.memo(WidgetRouteTruck);
